import { CurrencyCode } from '@99designs/i18n';
import { linkTo } from '@99designs/routing';
import type { ComparativeProduct } from '../types';

export type ProductNames =
    | 'logo-essential'
    | 'bronze-logo-contest'
    | 'gold-logo-contest'
    | 'full-service-branding';

export const getComparativeProductsByName = (name: ProductNames) => {
    const products: Record<ProductNames, ComparativeProduct> = {
        'logo-essential': {
            key: 'logo-essential',
            name: 'logo-essential',
            category: 'logo-design',
            title: __placeholder('Essential'),
            url: linkTo.briefCreate('logo-essential'),
            description: __placeholder(
                "Post your design job and we'll shortlist designers who are best suited to the job."
            ),
            pricing: {
                currency: CurrencyCode.USD,
                amountInCents: 0,
            },
            features: [
                { name: __placeholder('1 initial concept'), included: true },
                { name: __placeholder('Choose your designer from a shortlist'), included: true },
                { name: __placeholder('3-5 days turnaround time'), included: true },
                { name: __placeholder('2 rounds of revisions'), included: true },
                { name: __placeholder('1 logo variation'), included: true },
                { name: __placeholder('Money back guarantee'), included: false },
                {
                    name: __placeholder(
                        'Higher prize money attracts more design concepts (Not applicable)'
                    ),
                    included: false,
                },
            ],
            collaborationMethod: 'COLLABORATION_METHOD_ONE_TO_ONE_PROJECT',
        },
        'bronze-logo-contest': {
            key: 'bronze-logo-contest',
            name: 'bronze-logo-contest',
            category: 'logo-design',
            title: __placeholder('Bronze Contest'),
            url: linkTo.launchBrief('logo-design', { packageType: 'bronze' }),
            description: __placeholder(
                'Post your design job and receive entries from our community of creative professionals.'
            ),
            pricing: {
                currency: CurrencyCode.USD,
                amountInCents: 0,
            },
            features: [
                { name: __placeholder('Expect ~60 designs'), included: true },
                {
                    name: __placeholder('Any designer level can enter your contest'),
                    included: true,
                },
                { name: __placeholder('7 days contest duration'), included: true },
                {
                    name: __placeholder('Provide feedback to designers over 2 contest rounds'),
                    included: true,
                },
                { name: __placeholder('Up to 3 color variations'), included: true },
                { name: __placeholder('Money back guarantee'), included: true },
                {
                    name: __placeholder('Higher prize money attracts more design concepts'),
                    included: false,
                },
            ],
            collaborationMethod: 'COLLABORATION_METHOD_CONTEST',
            tier: 'bronze',
        },
        'gold-logo-contest': {
            key: 'gold-logo-contest',
            name: 'gold-logo-contest',
            category: 'logo-design',
            title: __placeholder('Gold Contest'),
            url: linkTo.launchBrief('logo-design', { packageType: 'gold' }),
            description: __placeholder(
                'Post your design job and receive entries from top rated designers with proven experience only.'
            ),
            pricing: {
                currency: CurrencyCode.USD,
                amountInCents: 0,
            },
            features: [
                { name: __placeholder('Expect ~90 designs'), included: true },
                { name: __placeholder('Mid & top level designers only'), included: true },
                { name: __placeholder('7 days contest duration'), included: true },
                {
                    name: __placeholder('Provide feedback to designers over 2 contest rounds'),
                    included: true,
                },
                { name: __placeholder('Up to 3 color variations'), included: true },
                { name: __placeholder('Money back guarantee'), included: true },
                {
                    name: __placeholder('Higher prize money attracts more design concepts'),
                    included: true,
                },
            ],
            collaborationMethod: 'COLLABORATION_METHOD_CONTEST',
            tier: 'gold',
        },
        'full-service-branding': {
            key: 'full-service-branding',
            name: 'full-service-branding',
            category: 'branding-design',
            title: __placeholder('Pro Studio'),
            url: '/pro/studio',
            description: __placeholder('Strategic branding from the top talent on 99designs.'),
            pricing: {
                currency: CurrencyCode.USD,
                amountInCents: 0,
            },
            features: [
                {
                    name: __placeholder(
                        'Work with our expert team of creative directors to craft a strategic brand that translates your business goals into a visual identity.'
                    ),
                    included: true,
                },
                {
                    name: __placeholder(
                        'Perfect for startups, scale ups, and innovative brand teams who want to bridge the gap between business goals and design outcomes, without hiring an in-house design team.'
                    ),
                    included: true,
                },
            ],
            collaborationMethod: 'COLLABORATION_METHOD_STUDIO',
        },
    };
    return products[name];
};
